import React, { useRef, useContext, useEffect, useState } from "react";

import { SendSMSAPI } from "../../utils/smsAPI";
import { Link, useLocation } from "react-router-dom";
import { ComboBoxComponent } from "@syncfusion/ej2-react-dropdowns";
import UiMosque from "../../utils/icons/UiMosque";

import "../user/dropdown.css";

import { Query } from "@syncfusion/ej2-data";
import data from "../../utils/Data/MosqueGeoLocations.json";

import {
  UilLocationPinAlt,
  UilLocationPoint,
  UilMapMarker,
  UilMapPin,
  UilUserLocation,
} from "@iconscout/react-unicons";
import { CustomerAPIEndpoint, endpoints } from "../../utils/customerapi";
import { getAreas } from "../../utils/SonicAPI";
import { UserContext } from "../../context/user.context";

export const MosqueSelection = ({ myMosqueSelection }) => {
  // Fix: Use useRef for proper referencing
  const countryObj = useRef(null);
  const stateObj = useRef(null);
  const cityObj = useRef(null);
  const areaObj = useRef(null);
  const mosqueObj = useRef(null);
  //console.log(mosqueId);

  // Country Data
  const countryFields = { text: "CountryName", value: "CountryID" };
  const countryData = data["country"];

  // State Data
  const stateFields = { text: "StateName", value: "StateID" };
  const stateData = data["state"];

  // City Data
  const citiesFields = { text: "CityName", value: "CityID" };
  const cityData = data["cities"];

  // Area Data
  const areaFields = { text: "areaName", value: "areaId" };
  //const areaData = data["areas"];

  // Mosque Data
  const mosqueFields = { text: "Description", value: "CustomerCode" };
  //const mosqueData = data["mosques"];

  // State to hold selected mosque
  // const [selectedMosque, myMosqueSelection] = useState({
  //   MosqueID: 0,
  //   MosqueName: "",
  // });
  const { sonicAccessToken } = useContext(UserContext);

  const [areaData, setAreaData] = useState([]);
  const [mosqueData, setMosqueData] = useState([]);

  // Fetch mosques based on selected area
  const fetchMosques = async (areaId) => {
    if (!areaId) return;

    try {
      const response = await CustomerAPIEndpoint(
        endpoints.getCustomersByAreaId
      ).getCustomersByAreaId(areaId);

      //console.log("Fetched Mosques:", response);
      setMosqueData(response.data); // Ensure the API response is in the correct format
      mosqueObj.current.enabled = true;
      mosqueObj.current.dataBind();
    } catch (error) {
      alert(
        "No Mosque Found! We are updating our Mosques List, please select other area"
      );
      console.error(
        "No Mosque Found! We are updating our Mosques List, please select other area",
        error
      );
    }
  };

  // Handle Country Change
  function countryChange() {
    if (
      !countryObj.current ||
      !stateObj.current ||
      !cityObj.current ||
      !mosqueObj.current
    )
      return;

    let selectedCountryId = countryObj.current.value;
    let stateQuery = new Query().where("CountryID", "equal", selectedCountryId);

    stateObj.current.query = stateQuery;
    stateObj.current.value = null;
    stateObj.current.dataBind();

    cityObj.current.value = null;
    cityObj.current.enabled = false;
    cityObj.current.dataBind();

    mosqueObj.current.value = null;
    mosqueObj.current.enabled = false;
    mosqueObj.current.dataBind();
  }

  // Handle State Change
  function stateChange() {
    if (!stateObj.current || !cityObj.current || !mosqueObj.current) return;

    let selectedStateId = stateObj.current.value;
    let cityQuery = new Query().where("StateID", "equal", selectedStateId);

    cityObj.current.query = cityQuery;
    cityObj.current.value = null;
    cityObj.current.enabled = true;
    cityObj.current.dataBind();

    mosqueObj.current.value = null;
    mosqueObj.current.enabled = false;
    mosqueObj.current.dataBind();
  }

  // Handle City Change
  function cityChange() {
    if (!cityObj.current || !areaObj.current) return;

    let selectedCityId = cityObj.current.value;
    // let areaQuery = new Query().where("CityID", "equal", selectedCityId);

    // areaObj.current.query = areaQuery;
    // areaObj.current.value = null;
    // areaObj.current.enabled = true;
    // areaObj.current.dataBind();

    fetchAreas(selectedCityId, sonicAccessToken);
    areaObj.current.value = null;
    areaObj.current.enabled = true;
    areaObj.current.dataBind();
  }

  const fetchAreas = async (cityID, token) => {
    if (!cityID) return;
    //console.log(`token from Mosque Selection ${token}`);

    try {
      const response = await getAreas(cityID, token);

      console.log("Fetched Areas:", response);
      setAreaData(response); // Ensure the API response is in the correct format
      areaObj.current.enabled = true;
      areaObj.current.dataBind();
    } catch (error) {
      alert(
        "No Area Found! We are updating our Areas List, please select other city"
      );
      console.error(
        "No Area Found! We are updating our Areas List, please select other city",
        error
      );
    }
  };

  // Handle Area Change
  function areaChange() {
    if (!areaObj.current || !mosqueObj.current) return;

    let selectedAreaId = areaObj.current.value;
    // console.log("Area ID from Mosque Selection:", selectedAreaId);
    // console.log("City ID from Mosque Selection:", cityObj.current.value);
    fetchMosques(selectedAreaId);

    mosqueObj.current.value = null;
    mosqueObj.current.enabled = false;
    mosqueObj.current.dataBind();
  }

  // Handle Mosque Selection
  function mosqueChange() {
    if (mosqueObj.current) {
      const selectedMosque = {
        MosqueID: mosqueObj.current.value,
        MosqueName: mosqueObj.current.text,
      };

      //console.log("Selected Mosque:", selectedMosque);
      myMosqueSelection(selectedMosque);
    }
  }

  useEffect(() => {
    //setCountryValue(1);
    //setStateValue(1);
    //setC(13);
    //set default country value
    countryObj.current.value = 1;
    countryObj.current.dataBind();
    countryObj.current.enabled = false;

    stateObj.current.value = 1;
    stateObj.current.dataBind();
    stateObj.current.enabled = false;

    cityObj.current.value = 13;
    cityObj.current.dataBind();
    cityObj.current.enabled = false;

    // countryObj.current.enabled = false;
    // stateObj.current.enabled = false;
    // cityObj.current.enabled = false;

    //if (cityObj.current) cityObj.current.enabled = false;
    //if (areaObj.current) areaObj.current.enabled = false;
    if (mosqueObj.current) mosqueObj.current.enabled = false;
  }, []);

  return (
    <div>
      <div>
        <div className="text-left ">
          <span className="text-base text-cool-gray-600 font-poppins font-normal">
            Select Nearest Mosque
          </span>
        </div>
        <form className="flex w-fit justify-start sm:max-w-sm md:max-w-screen-md lg:max-w-7xl">
          <div className="grid mx-auto justify-center sm:grid-cols-1 md:grid-cols-2 gap-x-4 ">
            {/* Country */}

            <div className="flex flex-row mt-2">
              <div
                className="bg-darkVeryLight ring-1 ring-secondary h-10 px-4 bg-zinc-100 rounded-tl-md rounded-bl-md 
justify-start items-center gap-4 inline-flex"
              >
                <UilLocationPinAlt className="text-gray-500 w-6" />
                <div className="font-normal text-P14 w-10">Country</div>
              </div>

              <div className="mx-auto justify-center w-full">
                <ComboBoxComponent
                  id="countryList"
                  placeholder="Select Country"
                  style={{ width: "100%", height: "38px" }}
                  fields={countryFields}
                  dataSource={countryData}
                  allowCustom={false}
                  ref={countryObj}
                  change={countryChange}
                />
              </div>
            </div>

            {/* State */}

            <div className="flex flex-row mt-2 ">
              <div
                className="bg-darkVeryLight ring-1 ring-secondary h-10 px-4 bg-zinc-100 rounded-tl-md rounded-bl-md 
justify-start items-center gap-4 inline-flex"
              >
                <UilLocationPoint className="text-gray-500 w-6" />
                <div className="font-normal text-P14 w-10">State</div>
              </div>

              <div className="mx-auto justify-center w-full">
                <ComboBoxComponent
                  id="stateList"
                  placeholder="Select State"
                  style={{ width: "100%", height: "38px" }}
                  fields={stateFields}
                  dataSource={stateData}
                  allowCustom={false}
                  ref={stateObj}
                  change={stateChange}
                />
              </div>
            </div>

            {/* City */}

            <div className="flex flex-row mt-2 ">
              <div
                className="bg-darkVeryLight ring-1 ring-secondary h-10 px-4 bg-zinc-100 rounded-tl-md rounded-bl-md 
justify-start items-center gap-4 inline-flex"
              >
                <UilMapMarker className="text-gray-500 w-6" />
                <div className="font-normal text-P14 w-10">City</div>
              </div>

              <div className="mx-auto justify-center w-full">
                <ComboBoxComponent
                  id="cityList"
                  placeholder="Select City"
                  style={{ width: "100%", height: "38px" }}
                  fields={citiesFields}
                  dataSource={cityData}
                  allowCustom={false}
                  ref={cityObj}
                  enabled={false} // Initially disabled
                  change={cityChange}
                />
              </div>
            </div>

            {/* Area */}

            <div className="flex flex-row mt-2 ">
              <div
                className="bg-darkVeryLight ring-1 ring-secondary h-10 px-4 bg-zinc-100 rounded-tl-md rounded-bl-md 
justify-start items-center gap-4 inline-flex"
              >
                <UilMapPin className="text-gray-500 w-6" />
                <div className="font-normal text-P14 w-10">Area</div>
              </div>

              <div className="mx-auto justify-center w-full">
                <ComboBoxComponent
                  id="areaList"
                  placeholder="Select Area"
                  style={{ width: "100%", height: "38px" }}
                  fields={areaFields}
                  dataSource={areaData}
                  allowCustom={false}
                  ref={areaObj}
                  enabled={false} // Initially disabled
                  change={areaChange}
                />
              </div>
            </div>

            {/* Mosque Selection */}

            <div className="flex flex-row mt-2 ">
              <div
                className="bg-darkVeryLight ring-1 ring-secondary h-10 px-4 bg-zinc-100 rounded-tl-md rounded-bl-md 
justify-start items-center gap-4 inline-flex"
              >
                <UiMosque fillColor="#00000" />
                <div className="font-normal text-P14 w-10">Mosque</div>
              </div>

              <div className="mx-auto justify-center w-full">
                <ComboBoxComponent
                  id="mosqueList"
                  style={{ width: "100%", height: "38px" }}
                  placeholder="Select Mosque"
                  fields={mosqueFields}
                  dataSource={mosqueData}
                  allowCustom={false}
                  ref={mosqueObj}
                  enabled={false} // Initially disabled
                  change={() => {
                    //console.log(myMosqueSelection);
                    mosqueChange();
                  }}
                />
              </div>
            </div>
          </div>

          <div className="mb-10"></div>
        </form>
      </div>
    </div>
  );
};
